import { Controller } from "@hotwired/stimulus"

// Left-rail section switcher for the platform builder. The builder's forms POST and
// full-reload, so the active screen is persisted (localStorage, keyed per app) and
// mirrored to the URL hash — after "Add table" the reload lands back on Tables, not
// the first screen. Pure show/hide; all panels are server-rendered up front.
export default class extends Controller {
  static targets = ["link", "panel"]
  static values = { key: String }

  connect() {
    const fromHash = (location.hash || "").replace(/^#/, "")
    const wanted = this.has(fromHash) ? fromHash : this.stored()
    this.show(this.has(wanted) ? wanted : this.firstName())
  }

  switch(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.section)
  }

  show(name) {
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.section !== name))
    this.linkTargets.forEach((l) => {
      const active = l.dataset.section === name
      l.classList.toggle("bg-indigo-50", active)
      l.classList.toggle("text-indigo-700", active)
      l.classList.toggle("font-semibold", active)
      l.classList.toggle("text-gray-600", !active)
    })
    try { localStorage.setItem(this.storageKey, name) } catch (_) { /* private mode */ }
    if (history.replaceState) history.replaceState(null, "", `#${name}`)
  }

  has(name) { return !!name && this.panelTargets.some((p) => p.dataset.section === name) }
  firstName() { return this.panelTargets[0]?.dataset.section }
  stored() { try { return localStorage.getItem(this.storageKey) } catch (_) { return null } }
  get storageKey() { return `pf_builder_section_${this.keyValue || "app"}` }
}
